import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

export default ({ year }) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'GET',
    url: 'parliamentary.amendment.estatistica.php',
    params: { ac: 'getSearch', year },
    headers: {
      token: decipher?.token?.value,
      action: 'getSearch',
    },
  });
}
